module.exports = __webpack_public_path__ + "static/media/add.d4c208ba.svg";